import axios from "axios";
import { createHashId } from "@util/signerId";

export const signatarioService = {
  async searchDefaultSigner(searchTerm) {
    const res = await axios.get("/assinaturas/signatarios", {
      params: { search: searchTerm },
    });
    const signersMapped = res.data.map((signer) => ({
      ...signer,
      registered: true, // marca os signatários retornados como cadastrados
    }));
    return signersMapped;
  },

  async searchCompanySigner(searchTerm, empresaId) {
    const res = await axios.get(`/assinaturas/signatarios/empresas/${empresaId}`, {
      params: { search: searchTerm },
    });
    const signersWithId = res.data.map((signer) => ({
      ...signer,
      id: createHashId(signer),
      registered: false,
    }));
    return signersWithId;
  },
};
